import { useCallback, useState } from 'react';

export type SelectedFilter = null | 'project' | 'type' | 'executors';

export const useTaskExtraFilters = () => {
    const [isShow, setIsShow] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState<SelectedFilter>(null);
    const changeShow = useCallback(() => setIsShow((prevState) => !prevState), []);
    const onSelectedFilter = (value?: SelectedFilter) => {
        if (selectedFilter !== value) {
        }
        setSelectedFilter(value);
    };

    return { isShow, changeShow, selectedFilter, onSelectedFilter, setIsShow };
};
